import { DispatchLeg } from '@api/Trinium/Endpoints/Dispatch/types';
import { defaultSortComparator } from '@components/DataGrid/types';
import { applyColumnQuickFilter, caseInsensitiveIncludes } from '../columns';
import RenderHeader from '@components/DataGrid/RenderHeader';
import RenderCell from '@components/DataGrid/RenderCell';
import { GridColDefExtended } from '@mui/x-data-grid-pro';

import styles from '../../RenderCell.module.css';

const traceResultDefinition: GridColDefExtended<DispatchLeg> = {
	field: 'Trc Result',
	minWidth: 140,
	width: 140,
	headerName: 'Trc Result',
	renderHeader: () => <RenderHeader primaryText='Trc Result' />,
	renderCell: ({ row }) => (
		<RenderCell
			primarySlot={
				row.traceResult && (
					<span
						className={styles.bold}
						title={row.traceResult.message}
					>
						{row.traceResult.message}
					</span>
				)
			}
			secondarySlot={row.traceResult && <span>{row.traceResult.timestamp}</span>}
		/>
	),
	disableReorder: true,
	getApplyQuickFilterFn: (value: string) => {
		return (_, row): boolean =>
			applyColumnQuickFilter(value, row, (value: string, row: DispatchLeg) => {
				const { trcResult } = row;
				return caseInsensitiveIncludes(value, [trcResult]);
			});
	},
	valueGetter: (_, row: DispatchLeg) => row.trcResult ?? '',
	sortable: true,
	sortComparator: defaultSortComparator
};

export default traceResultDefinition;
